import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { SchoolClass } from '../shared/school-class.model';
import { SchoolType } from '../shared/school-type.enum';
import { Arrays } from 'src/modules/utils/shared/arrays';

@Component({
  selector: 'app-school-class-list',
  standalone: false,
  templateUrl: './school-class-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './school-class-list.component.scss'
})
export class SchoolClassListComponent {
    _SchoolType = SchoolType;

    @Input()
    schoolClasses: SchoolClass[] = [];
    @Input()
    baseUrl = "";
    @Input()
    isHalfYear = false;

    getExistingGrades(): number[] {
        return Arrays.getUnique(this.schoolClasses.map(sc => sc.grade));
    }
}
